import { createFileRoute } from '@tanstack/react-router';
import { ClientsPage } from '@/features/clients';

/** Clients (maîtres d'ouvrage) of the organisation. */
export const Route = createFileRoute('/_auth/o/$orgId/clients/')({
  component: ClientsRoute,
});

function ClientsRoute() {
  const { orgId } = Route.useParams();
  return <ClientsPage orgId={orgId} />;
}
